

import React, { useRef, useEffect } from 'react';
import HtmlEditor from 'devextreme-react/html-editor';
import SignaturePad from 'react-signature-pad-wrapper';
import axios from '../../api/axios';
import { Button } from 'devextreme-react/button';
import html2pdf from 'html2pdf.js';
import './DocSablon.scss';


const DocImzala = ({ documentId, carRef, documentContent }) => {
  console.log('DocImzala rendered with:', { documentId, carRef, documentContent });
  const sigPadRef = useRef();
  const docContentRef = useRef();

  // Body'yi tam genişlik ve sıfır padding/margin yap
  useEffect(() => {
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.body.style.width = '100vw';
    document.body.style.maxWidth = '100vw';
    document.body.style.background = '#fff';
    return () => {
      document.body.style = '';
    };
  }, []);

  // Helper: Embed signature image into the document HTML at a fixed placeholder
  const embedSignatureInHtml = (html, signatureDataUrl) => {
    const parser = new window.DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const placeholder = doc.getElementById('imza-alani');
    const img = doc.createElement('img');
    img.src = signatureDataUrl;
    img.alt = 'İmza';
    img.style.maxWidth = '200px';
    img.style.maxHeight = '100px';
    img.style.display = 'block';
    img.style.marginTop = '10px';
    if (placeholder) {
      placeholder.innerHTML = '';
      placeholder.appendChild(img);
    } else {
      doc.body.appendChild(img);
    }
    return doc.body.innerHTML;
  };

  const handleSaveAndDownload = async () => {
    if (sigPadRef.current.isEmpty()) {
      alert('Lütfen imzanızı girin.');
      return;
    }
    if (!documentId || !carRef) {
      alert('Eksik parametre: Şablon veya Cari seçimi eksik!');
      return;
    }
    const imzaData = sigPadRef.current.toDataURL();
    // Embed signature into HTML
    const htmlWithSignature = embedSignatureInHtml(documentContent, imzaData);

    // Create a temporary element to render the HTML for PDF
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlWithSignature;
    tempDiv.style.background = 'white';
    tempDiv.style.padding = '20px';
    tempDiv.style.width = '800px';
    document.body.appendChild(tempDiv);

    // Generate PDF using html2pdf.js
    const opt = {
      margin: [10, 10, 5, 5],
      filename: `dokuman_${documentId}.pdf`,
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
    };

    // Use html2pdf to get the PDF as a Blob
    html2pdf().from(tempDiv).set(opt).outputPdf('blob').then(async (pdfBlob) => {
      // Remove the tempDiv from DOM
      document.body.removeChild(tempDiv);

      if (!pdfBlob || pdfBlob.size === 0) {
        console.error('PDF blob is empty or undefined:', pdfBlob);
        alert('PDF oluşturulamadı veya boş.');
        return;
      }

      // 1. Download for user
      const url = window.URL.createObjectURL(pdfBlob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `dokuman_${documentId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);

      // 2. Send to backend for saving
      const formData = new FormData();
      formData.append('documentId', documentId);
      formData.append('carRef', carRef);
      formData.append('pdf', pdfBlob, `dokuman_${documentId}.pdf`);
      console.log('Sending PDF to backend:', {
        documentId,
        carRef,
        pdfBlob,
        size: pdfBlob.size
      });
      try {
        await axios.post(
          `${process.env.REACT_APP_BACKEND_SERVER}sablonops/imza`,
          formData,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );
      } catch (err) {
        console.error('PDF sunucuya kaydedilemedi:', err);
        alert('PDF sunucuya kaydedilemedi.');
      }
    }).catch((err) => {
      document.body.removeChild(tempDiv);
      console.error('PDF oluşturulamadı:', err);
      alert('PDF oluşturulamadı.');
    });
  };

  return (
    <div className="doc-imzala-container">
      <div className="doc-content" ref={docContentRef}>
        {/* Doküman içeriği burada gösterilecek */}
        <HtmlEditor value={documentContent} readOnly={true} height={600} />
      </div>
      <div className="signature-section" style={{ marginTop: 32, textAlign: 'center' }}>
        <SignaturePad ref={sigPadRef} options={{ minWidth: 1, maxWidth: 2.5, penColor: 'black', backgroundColor: 'rgba(255,255,255,0)' }} />
        <div style={{ marginTop: 16, display: 'flex', justifyContent: 'center', gap: 16 }}>
          <Button text="Temizle" onClick={() => sigPadRef.current.clear()} style={{ fontSize: 18, padding: '12px 32px' }} />
          <Button text="Kaydet ve PDF İndir" type="success" onClick={handleSaveAndDownload} style={{ fontSize: 20, fontWeight: 'bold', padding: '16px 40px', background: '#43a047', color: '#fff', borderRadius: 8, boxShadow: '0 2px 8px #43a04755' }} />
        </div>
      </div>
    </div>
  );
};

export default DocImzala;
